import PricingList from './PricingList';
import PricingShow from './PricingShow';

export default {
  list: PricingList,
  show: PricingShow,
};
